module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm.qtfFalhas))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.idioma === 'DE') ? _c('li', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.qtfFalhas) + " Fehler wurden identifiziert")]) : (_vm.idioma === 'EN') ? _c('li', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.qtfFalhas) + " fault(s) were identified")]) : (_vm.idioma === 'ES') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Se identificaron " + _vm._s(_vm.qtfFalhas) + " fallas")]) : _c('li', {
    staticClass: "header"
  }, [_vm._v("Foram identificadas " + _vm._s(_vm.qtfFalhas) + " falha(s)")]), _vm._v(" "), (_vm.Falhas.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.Falhas), function(message, key) {
    return _c('message-item', {
      key: key,
      attrs: {
        "message": message
      }
    })
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [(_vm.idioma === 'DE') ? _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Nah dran")]) : (_vm.idioma === 'EN') ? _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Close")]) : (_vm.idioma === 'ES') ? _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Cerrar")]) : _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Fechar")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f262db3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MessagesMenu.vue
// module id = 683
// module chunks = 1